import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: COLOR_PURPLE,
  },
  mainBoxContent: {
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: 6,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(4, 6),
  },
  textReasons: {
    fontSize: 28,
    color: COLOR_PURPLE,
    paddingTop: theme.spacing(6),
  },
  list: {
    padding: theme.spacing(0),

    '& li': {
      fontSize: 24,
      paddingBottom: theme.spacing(2),
    },
  },
  mainForm: {
    boxShadow: '0px 3px 6px #00000029',
    border: '1px solid #EEEEEE',
    borderRadius: 6,
    padding: theme.spacing(3),
    width: 450,
  },
  inputTextName: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(2),

    '& span': {
      color: '#F01C10',
    },
  },
}));
